import { Icons } from '@cockpitai/components/atoms'
import { useSideBar } from '@cockpitai/components/organisms/Sidebar/SideBarContext'
import { routesPath } from '@cockpitai/constants/routesPath'
import { isMobile } from '@cockpitai/utils/device'
import { NavLink } from 'react-router-dom'
import { HistoryChat } from './components/HistoryChat'
import { NewChat } from './components/NewChat'

export function HeaderChatActions() {
  const { setSidebarIsOpen } = useSideBar()

  const handleOpenSideBar = () => {
    setSidebarIsOpen(true)
  }

  return isMobile() ? (
    <div className="flex w-full justify-between">
      <div className="flex gap-1">
        <NavLink to={routesPath.dashboard.home} className="flex gap-2">
          {import.meta.env.VITE_CONSULTANT === 'true' ? (
            <Icons.ConsultaAIGray width={40} height={40} />
          ) : (
            <Icons.SantanderRounded width={40} height={40} />
          )}
        </NavLink>

        <button
          className="mr-1 flex w-10 items-center justify-center rounded-md bg-gray-850 p-1"
          onClick={handleOpenSideBar}>
          <Icons.Hamburger className="text-white" />
        </button>
      </div>
      <NewChat />
    </div>
  ) : (
    <div className="flex flex-row-reverse gap-[0.125rem] rounded-lg">
      <HistoryChat />
      <NewChat />
    </div>
  )
}
